module.exports = __webpack_public_path__ + "se.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/se.svg
// module id = 1050
// module chunks = 0